<template>
  <div class="org-detail">
    <div class="detail-bg"></div>

    <div class="content">
      <div class="left-con">
        <!-- 重点人员 -->
        <section-box style='margin-top: 0' v-loading="scholarsLoading">
          <template v-slot:title>
            <p class="border-text">重点人员</p>
          </template>
          <template v-slot:main>
            <div class="expert-list">
              <div class="flex justify-between item-center">
                <el-radio-group
                  v-model="scholarsTypeValue"
                  @change="handleScholarTypeChange"
                >
                  <el-radio-button
                    v-for="item in scholarsTypeOption"
                    :key="item.value"
                    :label="item.value"
                    :disabled="orgType !== 'academic' && item.label !== '全部'"
                  >
                    {{ item.label }}
                  </el-radio-button>
                </el-radio-group>

<!--                <el-select-->
<!--                  v-model="expertChanyeValue"-->
<!--                  size="small"-->
<!--                  placeholder="请选择领域"-->
<!--                  style="margin-top: 15px"-->
<!--                  @change="handleExpertChanyeChange"-->
<!--                >-->
<!--                  <el-option-->
<!--                    v-for="item in expertChanyeOptions"-->
<!--                    :key="item.id"-->
<!--                    :label="item.name"-->
<!--                    :value="item.id"-->
<!--                  >-->
<!--                  </el-option>-->
<!--                </el-select>-->
              </div>

              <!-- 人才列表 -->
              <org-scholars-list
                :scholars-data="scholarsData"
                v-if="scholarsData.length > 0"
              />
              <div v-else style="height: 310px">
                <el-empty  />
              </div>
              <div class="page-container" v-if="scholarsData.length > 0">
                <el-pagination
                  background
                  @current-change="handleScholarsPageChange"
                  :current-page="scholarsPager.pageNum"
                  :page-size="scholarsPager.pageSize"
                  layout="prev, pager, next"
                  :total="scholarsPager.total"
                />
              </div>
            </div>
          </template>
        </section-box>
        <!-- 成果分析 -->
        <section-box
          style="margin-top: 10px"
          v-if="riverData.legend != null && riverData.legend.length > 0"
        >
          <template v-slot:title>
            <p class="border-text">成果分析</p>
          </template>
          <template v-slot:main>
            <div
              style="height: 350px; position: relative; width: 100%"
              v-if="riverData.legend.length > 0"
            >
              <!--              <achievement-analyse-bar/>-->
              <scholar-interest-chart :data="riverData" />
            </div>
            <div v-else style="height: 350px">
              <el-empty  />
            </div>
          </template>
        </section-box>

        <!-- 趋势分析 -->
        <section-box
          style="margin-top: 10px"
          v-if="trendAnalyseYear != null && trendAnalyseYear.length > 0"
        >
          <template v-slot:title>
            <p class="border-text">趋势分析</p>
          </template>
          <template v-slot:main>
            <div v-loading="echartsLoading">
              <div
                style="height: 350px; position: relative; width: 100%"
                v-if="trendAnalyseYear != null && trendAnalyseYear.length > 0"
              >
                <trend-analyse-bar
                  :trend-analyse-year="trendAnalyseYear"
                  :trend-analyse-count="trendAnalyseCount"
                />
              </div>
              <div v-else style="height: 350px">
                <el-empty  />
              </div>
            </div>
          </template>
        </section-box>

        <!-- 相关基地 -->
        <section-box
          v-if="
            orgArea === '国内' && orgType === 'academic' && basesData.length
          "
          style="margin-top: 10px"
          v-loading="basesLoading"
        >
          <template v-slot:title>
            <p class="border-text">相关基地</p>
          </template>
          <template v-slot:main>
            <org-bases-list :bases-data="basesData" v-if="basesData.length" />
            <div v-else style="height: 310px">
              <el-empty  />
            </div>

            <div class="page-container" v-if="basesData.length">
              <el-pagination
                background
                @current-change="handleBasesPageChange"
                :current-page="basesPager.pageNum + 1"
                :page-size="basesPager.pageSize"
                layout="prev, pager, next"
                :total="basesPager.total"
              />
            </div>
          </template>
        </section-box>

        <!-- 科研成果 -->
        <section-box style="margin-top: 10px">
          <template v-slot:title>
            <p class="border-text">科研成果</p>
          </template>
          <template v-slot:main>
            <div class="achieve-list" v-loading="achievementLoading">
              <div class="flex justify-between item-center">
                <el-radio-group
                  v-model="achieveTypeValue"
                  @change="handleAchieveTypeChange"
                >
                  <el-radio-button
                    v-for="item in achieveTypeOption"
                    :key="item.name"
                    :label="item.label"
                  >
                    {{ item.label }} ({{ item.count }})
                  </el-radio-button>
                </el-radio-group>

                <el-select
                  v-if="achieveTypeValue !== '奖项' && orgArea === '国内' && false"
                  v-model="achieveChanyeValue"
                  size="small"
                  placeholder="请选择产业"
                  style="margin-top: 15px"
                  @change="handleAchieveChanyeChange"
                >
                  <el-option
                    v-for="item in achieveChanyeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div v-if='achievementData.length === 0' style='height: 310px'>
                <el-empty/>
              </div>
              <achievement-list
                v-else
                :active-value="achieveTypeValue"
                :achievementData="achievementData"
                :search-comp="false"
                :total="0"
                :paperArea="orgArea"
              />
            </div>

            <div
              class="page-container"
              v-if="achievementData && achievementData.length"
            >
              <el-pagination
                background
                @current-change="handleAchievePageChange"
                :current-page="achievementPager.pageNum + 1"
                :page-size="achievementPager.pageSize"
                layout="prev, pager, next"
                :total="achievementPager.total"
              />
            </div>
          </template>
        </section-box>

        <section-box
          style="margin-top: 10px"
          :show-extra="true"
          :extra-width="350"
          v-if="
            orgArea === '国内' &&
            orgType === 'academic' &&
            schoolListData.length
          "
        >
          <template v-slot:title>
            <p class="border-text">招生计划</p>
          </template>
          <template v-slot:extra>
            <div class="school-title-layout flex items-center">
              <p class="school-year-text">年份</p>
              <el-select :value="schoolYearValue" @change="schoolYearChange">
                <el-option
                  v-for="item in schoolYearOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <p class="school-city-text">所在地</p>
              <el-cascader
                @change="schoolCityChange"
                v-model="city.myCity"
                placeholder="所在地"
                :options="city.domesticCityData"
                :props="{
                  expandTrigger: 'hover',
                  value: 'regionName',
                  label: 'regionName',
                }"
              ></el-cascader>
            </div>
          </template>
          <template v-slot:main>
            <div v-loading="schoolListLoading">
              <org-school-list
                :school-data="schoolListData"
                v-if="schoolListData.length"
              />
              <div v-else style="height: 310px">
                <el-empty  />
              </div>
            </div>

            <div class="page-container" v-if="schoolListData.length">
              <el-pagination
                background
                @current-change="handleSchoolYearPageChange"
                :current-page="schoolYearPager.pageNum + 1"
                :page-size="schoolYearPager.pageSize"
                layout="prev, pager, next"
                :total="schoolYearPager.total"
              />
            </div>
          </template>
        </section-box>
      </div>

      <div class="right-con">
        <!-- <div id="boxFixed" :class="isFixed ? 'isFixed' : ''"> -->
        <div class="sticky">
          <org-infor
            :info-loading="infoLoading"
            :org-detail-data="orgDetailData"
            :org-type="orgType"
          />
          <section-box
            style="margin-top: 9px"
            v-if="hotWordData != null && hotWordData.length > 0"
          >
            <template v-slot:title>
              <p class="border-text">核心技术</p>
            </template>
            <template v-slot:main>
              <div
                style="height: 310px; width: 100%"
                v-if="hotWordData != null && hotWordData.length > 0"
              >
                <scholar-hot-word :hot-data="hotWordData" domId="detail" />
              </div>
              <div v-else style="height: 310px">
                <el-empty  />
              </div>
            </template>
          </section-box>
          <div
            class="industrial-distribution"
            v-if="orgArea === '国内' && orgType === 'company'"
          >
            <section-box >
              <template v-slot:title>
                <p class="border-text">产业分布</p>
              </template>
              <template v-slot:main>
                <div class="charts-con">
                  <industrial-distribution :data="industryRadarData" />
                </div>
              </template>
            </section-box>
          </div>
          <section-box style="margin-top: 9px" v-if="false">
            <template v-slot:title>
              <p class="border-text">相关动态</p>
            </template>
            <template v-slot:main>
              <dynamic-list />
            </template>
          </section-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sectionBox from '@/views/org/comps/sectionBox.vue';
import orgInfor from '@/views/org/comps/orgInfor';
import orgScholarsList from './comps/orgScholarsList';
import orgBasesList from '@/views/org/comps/orgBasesList';
import achievementList from '@/views/org/comps/achievementList';
import industrialDistribution from './comps/industrialDistribution';

import {
  getOrgDetailApi,
  getOrgScholarsListApi,
  getOrgBasesListApi,
  getOrgPapersListApi,
  getOrgPatentsListApi,
  getOrgProjectsListApi,
  getOrgAwardsListApi,
  getOrgIndustryRadarApi,
  getOrgEnrollmentPlanApi,
  getOrgPapersAnalysisApi,
  getCountryChinaAllApi,
  getFieldMapApi
} from '@/api/orgDetail';
import ScholarHotWord from '@/views/org/comps/scholarHotWord';
import DynamicList from '@/views/org/comps/dynamicList';
import TrendAnalyseBar from '@/views/org/comps/trendAnalyseBar';
import ScholarInterestChart from '@/views/org/comps/scholarInterestChart.vue';
import OrgSchoolList from '@/views/org/comps/orgSchoolList.vue';

export default {
  name: 'orgDetail',
  components: {
    OrgSchoolList,
    ScholarInterestChart,
    TrendAnalyseBar,
    DynamicList,
    ScholarHotWord,
    sectionBox,
    orgInfor,
    orgScholarsList,
    orgBasesList,
    achievementList,
    industrialDistribution,
  },
  data() {
    return {
      isBack: null,
      backName: null,
      scholarsTypeValue: 0,
      scholarsTypeOption: [],
      achieveTypeValue: '',
      achieveTypeOption: [],
      scholarsPager: {
        pageNum: 1,
        pageSize: 8,
        total: 0,
      },
      basesPager: {
        pageNum: 0,
        pageSize: 6,
        total: 0,
      },
      schoolYearPager: {
        pageNum: 0,
        pageSize: 6,
        total: 0,
      },
      achievementPager: {
        pageNum: 0,
        pageSize: 6,
        total: 0,
      },
      infoLoading: false,
      scholarsLoading: false,
      basesLoading: false,
      achievementLoading: false,
      orgDetailData: {
        nameCn: '',
        nameEn: '',
        logoUrl: '',
        description: '',
        innovationIndex: 0,
        country: '',
        province: '',
        city: '',
        district: '',
        fieldList: [],
        interestList: [],
      },
      scholarsData: [],
      basesData: [],
      achievementData: [],
      industryRadarData: [],

      orgId: '',
      orgArea: '',
      orgType: '',

      schoolYearValue: '',
      schoolYearOptions: [],
      schoolListData: [],
      schoolListLoading: false,
      //城市/国家
      city: {
        domesticCityData: [], //国内
        abroadCityData: [], //国外
        myCity: '北京市', //选中
      },

      hotWordData: [],
      // 吸顶
      // isFixed: false,
      // offsetTop: 0,
      // 趋势分析
      trendAnalyseYear: [],
      trendAnalyseCount: {
        citationCount: [],
        achievmtCount: [],
      },
      ///成果分析
      riverData: {
        data: ['empty'],
        legend: [],
      },
      echartsLoading: false,

      expertChanyeValue: null,
      achieveChanyeValue: null,
      expertChanyeOptions: [],
      achieveChanyeOptions: [],
      industryId: null,
    };
  },
  async created() {
    this.orgId = this.$route.query.orgId;
    this.orgArea = this.$route.query.orgArea;
    this.orgType = this.$route.query.type === 'company' ? 'company' : 'academic';
    this.industryId = this.$route.query.industryId || null;
    this.isBack = this.$route.query.isBack;
    this.backName = this.$route.query.backName;


    if (this.orgType === 'academic') {
      if (this.orgArea === '国内') {
        this.scholarsTypeOption = [
          { label: '全部', value: 0 },
          { label: '院士', value: 1 },
          { label: '国家级人才', value: 2 },
          { label: '知名学者', value: 3 },
        ];
      } else {
        this.scholarsTypeOption = [
          { label: '全部', value: 0 },
          { label: '国家级人才', value: 2 },
          { label: '知名学者', value: 3 },
        ];
      }
    } else if (this.orgType === 'company') {
      this.scholarsTypeOption = [
        { label: '全部', value: 0 },
        { label: '董事', value: 1 },
        { label: '监理', value: 2 },
        { label: '高管', value: 3 },
        { label: '技术人才', value: 4 },
      ];
    }

    this.getOrgDetail(); // 机构基本信息
    this.getOrgScholarsList(); // 专家列表
    if (this.orgArea === '国内') {
      this.getOrgPapersAnalysis();
    }
    if (this.orgArea === '国内' && this.orgType === 'academic') {
      this.getOrgBasesList(); // 相关基地
    }
    if (this.orgArea === '国内' && this.orgType === 'company') {
      this.getOrgIndustryRadar(); // 企业产业雷达图
    }

    this.getIndustryList();
    this.getCountryChina();
    let year = new Date().getFullYear();
    this.schoolYearValue = year - 1;
    for (let i = 0; i < 5; i++) {
      year--;
      this.schoolYearOptions.push({ value: year, label: year });
    }
  },
  // mounted() {
  //   // handleScroll为页面滚动的监听回调
  //   window.addEventListener('scroll', this.handleScroll);
  //   this.$nextTick(() => {
  //     //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置
  //     this.offsetTop = document.querySelector('#boxFixed').offsetTop;
  //   })
  // },
  // destroyed(){
  //   window.removeEventListener('scroll', this.handleScroll);
  // },
  methods: {
    // 学者（重点人员）类型切换
    handleScholarTypeChange(val) {
      this.scholarsTypeValue = val;
      this.scholarsPager.pageNum = 1;
      this.getOrgScholarsList();
    },

    // 论文、专利、项目、奖项切换
    handleAchieveTypeChange(val) {
      this.achievementData = [];
      this.achievementPager.pageNum = 0;

      this.achievementTypeFn(val);
    },

    // 获取机构详情-学者列表
    getOrgScholarsList() {
      this.scholarsLoading = true;
      let pa = {
        orgId: this.orgId,
        orgName: this.orgDetailData.nameCn,
        scholarType: this.scholarsTypeValue,
        industryId: this.expertChanyeValue || this.industryId,
        pageNum: this.scholarsPager.pageNum,
        pageSize: this.scholarsPager.pageSize,
        // nativeProvince: this.nativePlaceParams.nativeProvince,
        // nativeCity: this.nativePlaceParams.nativeCity,
        // nativeDistrict: this.nativePlaceParams.nativeDistrict,
        // countryType: '',
        // scholarName: this.scholarParams.scholarName,
      }
      getOrgScholarsListApi(pa)
        .then((res) => {
          if (res.code === 200) {
            this.scholarsData = res.data.records;
            this.scholarsPager.total = res.data.total;

            this.scholarsData.map((item) => {
              item.companyTitleListStr = item.companyTitleList.join('；');
              item.scholarId = item.id;
              item.achievementNum =
                item.paperNum +
                item.patentNum +
                item.projectNum +
                item.awardNum;
            });
          }
          this.scholarsLoading = false;
        })
        .catch(() => {
          this.scholarsLoading = false;
        });
    },

    // 获取机构-基地列表
    getOrgBasesList() {
      this.basesLoading = true;
      getOrgBasesListApi(this.orgId, {
        pageNum: this.basesPager.pageNum,
        pageSize: this.basesPager.pageSize,
        isAbroad: 0,
      })
        .then((res) => {
          this.basesData = res.data.content;
          this.basesPager.total = res.data.totalElements;

          this.basesLoading = false;
        })
        .catch(() => {
          this.basesLoading = false;
        });
    },

    // 获取机构基本信息
    getOrgDetail() {
      // this.infoLoading = true;
      getOrgDetailApi(this.orgId, {
        isAbroad: this.orgArea === '国内' ? 0 : 1,
        industryId: this.achieveChanyeValue || this.industryId,
      })
        .then((res) => {
          // console.log(res);
          if (res.code === 200) {
            this.orgDetailData = res.data;
            if (this.orgArea === '国内' && this.orgType === 'academic') {
              this.getOrgEnrollmentPlan();
            }
            let pubCount = res.data.pubCount;
            let data = [];
            pubCount.map((item) => {
              // console.log('pubCount', item);
              if (item.count !== 0) {
                if (item.name === 'patent') {
                  data.unshift(item);
                } else {
                  // console.log('paper', item.name);
                  data.push(item);
                }
              }
            });
            this.achieveTypeOption = [];
            // console.log('data', data);
            data.map((item, index) => {
              // console.log(item);
              if (item.name === 'patent') {
                item.label = '专利';
                this.achieveTypeOption.push({
                  label: '专利',
                  count: item.count,
                });
                this.achieveTypeValue = '专利';
                this.getAchievementData(getOrgPatentsListApi); // 科研成果列表
              } else if (item.name === 'paper') {
                // console.log('论文');
                item.label = '论文';
                this.achieveTypeOption.push({
                  label: '论文',
                  count: item.count,
                });
                if (index == 0) {
                  this.achieveTypeValue = '论文';
                  this.getAchievementData(getOrgPapersListApi); // 科研成果列表
                }
              } else if (item.name === 'project') {
                item.label = '项目';
                this.achieveTypeOption.push({
                  label: '项目',
                  count: item.count,
                });
              } else if (item.name === 'award') {
                item.label = '奖项';
                this.achieveTypeOption.push({
                  label: '奖项',
                  count: item.count,
                });
              }
            });
            this.orgDetailData.fieldListStr = res.data.fieldList?.join('；');
            this.orgDetailData.interestListStr =
              res.data.interestList?.join('；');
          }
          this.infoLoading = false;
        })
        .catch(() => {
          this.infoLoading = false;
        });
    },
    /**
     * 获取国内高校招生计划
     */
    getOrgEnrollmentPlan() {
      this.schoolListLoading = true;
      let param = {
        pageNo: this.schoolYearPager.pageNum,
        pageSize: this.schoolYearPager.pageSize,
        provinceName: this.city.myCity,
        // regionCode:'1100',
        year: this.schoolYearValue,
      };
      getOrgEnrollmentPlanApi(this.orgDetailData.nameCn, param)
        .then((res) => {
          if (res.code === 200) {
            this.schoolListData = res.data.content;
            this.schoolYearPager.total = res.data.totalElements;
          }
          this.schoolListLoading = false;
        })
        .catch((err) => {
          console.log(err)
          this.schoolListLoading = false;
        });
    },
    /**
     * 获取机构详情-成果分析(论文领域统计)-趋势分析(论文总数与引用数统计)-核心技术(论文关键词统计)
     */
    getOrgPapersAnalysis() {
      this.echartsLoading = true;
      this.trendAnalyseYear = [];
      getOrgPapersAnalysisApi(this.orgId)
        .then((res) => {
          if (res.code == 200) {
            let _papersYearAnalysisList = res.data.papersYearAnalysisList;
            let _topKeywords = res.data.topKeywords;
            let _topKeywordsCnt = res.data.topKeywordsCnt;
            _papersYearAnalysisList.map((item) => {
              this.trendAnalyseYear.push(item.year);
              this.trendAnalyseCount.citationCount.push(item.citationNum);
              this.trendAnalyseCount.achievmtCount.push(item.count);
            });
            _topKeywords.map((item, index) => {
              this.hotWordData.push({
                name: item,
                value: _topKeywordsCnt[index],
              });
            });

            // set up legends of river
            if (_papersYearAnalysisList.length > 0) {
              let legend = [];
              for (let i in _papersYearAnalysisList[0].topDomainsCnt) {
                let tempKey = Object.keys(
                  _papersYearAnalysisList[0].topDomainsCnt[i]
                )[0];
                if (!tempKey || tempKey === 'null') tempKey = '未知学科' + i;
                //console.log(tempKey)
                legend.push(tempKey);
              }
              //console.log({'testKey' :that.result.riverData.legend})
              let tempRes = [];
              let currentYear = 0;
              let previousYear = 0;
              let splitIndex = 0;
              for (let i in _papersYearAnalysisList) {
                let year = _papersYearAnalysisList[i].year;
                currentYear = parseFloat(year);
                // 如果连续20年为空则停止遍历，并去除以保留的20年空白数据
                // 空既为数据为0
                if (currentYear - previousYear <= -20) {
                  break;
                }
                let count = 0;
                for (let j in _papersYearAnalysisList[i].topDomainsCnt) {
                  let tempKey = Object.keys(
                    _papersYearAnalysisList[i].topDomainsCnt[j]
                  )[0];
                  let tempValue = Object.values(
                    _papersYearAnalysisList[i].topDomainsCnt[j]
                  )[0];
                  count += tempValue;
                  if (!tempKey || tempKey === 'null') tempKey = legend[j];
                  if (!tempValue) tempValue = 0;
                  tempRes.push([year, tempValue, tempKey]);
                }
                if (count > 0) {
                  previousYear = currentYear;
                  splitIndex = i;
                }
              }
              if (splitIndex > 0) {
                let cut =
                  (parseInt(splitIndex) + 1) *
                  _papersYearAnalysisList[0].topDomainsCnt.length;
                tempRes.splice(cut);
              }
              this.riverData = {
                data: tempRes,
                legend: legend,
              };
              if (this.isScholarNaN) {
                this.getScholarWord();
              }
            }

            this.trendAnalyseYear.reverse();
            this.trendAnalyseCount.citationCount.reverse();
            this.trendAnalyseCount.achievmtCount.reverse();
          }
          this.echartsLoading = false;
        })
        .catch((err) => {
          console.log(err)

          this.echartsLoading = false;
        });
    },

    // 获取成果（论文、专利、项目、奖项）列表
    getAchievementData(apiFn) {
      this.achievementLoading = true;
      apiFn(this.orgId, {
        pageNum: this.achievementPager.pageNum,
        pageSize: this.achievementPager.pageSize,
        industryId: this.achieveChanyeValue || this.industryId,
        isAbroad: this.orgArea === '国内' ? 0 : 1,
      })
        .then((res) => {
          if (this.achieveTypeValue === '论文') {
            this.achievementData = res.data.data;
            this.achievementPager.total = res.data.totalCount;
            this.achievementData.map((item) => {
              item.authors = item.authorList.splice(0, 5);
              item.venue = item.journalConf;
              item.citationNum = item.citationCount;
              item.date = item.pubDate;
            });
          } else if (this.achieveTypeValue === '专利') {
            this.achievementData = res.data.content;
            this.achievementPager.total = res.data.totalElements;
          } else if (this.achieveTypeValue === '项目') {
            this.achievementData = res.data.content;
            this.achievementPager.total = res.data.totalElements;
          } else {
            this.achievementData = res.data.content;
            this.achievementPager.total = res.data.totalElements;
            this.achievementData.map((item) => {
              item.authors = item.authors && item.authors.splice(0, 3);
              if (item.degree === 1) item.degreeCn = '一';
              if (item.degree === 2) item.degreeCn = '二';
              if (item.degree === 3) item.degreeCn = '三';
              if (item.degree === 4) item.degreeCn = '四';
              if (item.degree === 5) item.degreeCn = '五';
            });
          }

          this.achievementLoading = false;
        })
        .catch(() => {
          this.achievementLoading = false;
        });
    },
    // 封装调接口函数
    achievementTypeFn(type) {
      if (type === '论文') {
        this.getAchievementData(getOrgPapersListApi);
      } else if (type === '专利') {
        this.getAchievementData(getOrgPatentsListApi);
      } else if (type === '项目') {
        this.getAchievementData(getOrgProjectsListApi);
      } else if (type === '奖项') {
        this.getAchievementData(getOrgAwardsListApi);
      }
    },

    // 获取企业产业雷达图（产业分布）
    getOrgIndustryRadar() {
      getOrgIndustryRadarApi(this.orgId).then((res) => {
        this.industryRadarData = res.data;

        this.industryRadarData?.map((item) => {
          item.name = item.industry;
          item.value = item.count;
        });
      });
    },

    // 学者（重点人员）分页
    handleScholarsPageChange(current) {
      this.scholarsPager.pageNum = current;
      this.getOrgScholarsList();
    },

    // 相关基地 分页
    handleBasesPageChange(current) {
      this.basesPager.pageNum = current - 1;
      this.getOrgBasesList();
    },

    // 科研成果分页
    handleAchievePageChange(cur) {
      this.achievementPager.pageNum = cur - 1;
      this.achievementTypeFn(this.achieveTypeValue);
    },
    // 招生计划分页
    handleSchoolYearPageChange(cur) {
      this.schoolYearPager.pageNum = cur - 1;
      this.getOrgEnrollmentPlan();
    },
    // 招生计划年份切换
    schoolYearChange(val) {
      console.log(val);
      this.schoolYearValue = val;
      this.getOrgEnrollmentPlan();
    },
    // 招生计划省份切换
    schoolCityChange(val) {
      console.log(val);
      this.schoolYearPager.pageNum = 0;
      this.city.myCity = val[0];
      this.getOrgEnrollmentPlan();
    },
    /**
     *  获取国内省市
     */
    getCountryChina() {
      getCountryChinaAllApi()
        .then((res) => {
          if (res.code == 200) {
            res.data.map((item) => {
              item.disabled = false;
              if (item.child) {
                item.child = [];
              }
            });
            this.city.domesticCityData = res.data;
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },

    // handleScroll(){
    //   // 得到页面滚动的距离
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //   // 判断页面滚动的距离是否大于吸顶元素的位置
    //   this.isFixed = scrollTop > (this.offsetTop + 110);
    // },

    // 专家列表产业切换
    handleExpertChanyeChange(val) {
      console.log(val);
      this.industryId = null;
      this.getOrgScholarsList();
    },

    // 成果列表产业切换
    handleAchieveChanyeChange(val) {
      console.log(val)
      console.log(this.achieveTypeValue);
      this.achievementTypeFn(this.achieveTypeValue);
      this.getOrgDetail();

      this.industryId = null;
    },

    // 获取产业列表
    getIndustryList() {
      getFieldMapApi()
        .then((res) => {
          if (res.code === 200) {
            res.data.unshift({ value: null, name: '全部' });
            this.expertChanyeOptions = res.data;
            this.achieveChanyeOptions = res.data;
            if (this.industryId) {
              this.expertChanyeValue = Number(this.industryId);
              this.achieveChanyeValue = Number(this.industryId);
            }
          }
        })
        .catch(() => {});
    },
  },
  watch: {},
};
</script>

<style scoped lang="less">
.org-detail {
  background: linear-gradient(
    0deg,
    rgba(242, 244, 247, 0) 0%,
    rgba(2, 91, 206, 0.1) 100%
  );
  width: 100%;
  height: 100%;

  .content {
    width: 100%;
    padding: 5px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    position: relative;

    .left-con {
      margin-left: 10px;
      width: 70%;

      .expert-list {
        min-height: 300px;
      }

      .bases-list {
      }
    }

    .right-con {
      margin: 0 10px;
      width: 350px;
      overflow: visible;

      .industrial-distribution {
        margin-top: 10px;
        background-color: #ffffff;
        box-sizing: border-box;
        border-radius: 6px;

        .charts-con {
          width: 100%;
          height: 350px;
        }
      }
    }
  }
}

.expert-list,
.achieve-list {
  text-align: left;

  /deep/ .el-radio-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-left: 10px;
    margin-top: 10px;

    .el-radio-button {
      margin-right: 20px;
    }

    .el-radio-button__inner {
      font-weight: 400;
      padding: 10px 20px !important;
      font-size: 14px;
      border-radius: 4px;
      border: none !important;
      box-shadow: none !important;
      color: #666 !important;
      background-color: unset !important;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #2e1f88 !important;
      font-size: 14px;
      //background: #0C78C1!important;
    }
  }
}

.school-title-layout {
  > p {
    margin-right: 5px;
    font-size: 14px;
  }

  .school-city-text {
    margin-left: 20px;
  }

  /deep/ .el-input__inner {
    width: 117px;
    height: 32px;
    font-size: 14px;
    line-height: 32px;
  }
}

.achieve-list {
  /deep/ .achievement-list {
    line-height: 1;
    margin: 0;
    padding: 0px 20px;
  }
}

.page-container {
  text-align: center;
  background-color: #ffffff;
  padding: 20px 0;

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1241C9;
    color: #ffffff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    border-radius: 4px;
    background-color: #ffffff;
    min-width: 30px;
    height: 28px;
    color: #333333;
    line-height: 28px;
  }
  /deep/ .el-pagination.is-background {
    .btn-next {
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
      background-color: #ffffff;
      .el-icon-arrow-right:before {
        content: '\e791';
      }
    }

    .btn-prev {
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
      background-color: #ffffff;
      .el-icon-arrow-left:before {
        content: '\e792';
      }
    }
  }
}

.isFixed {
  position: fixed;
  width: 350px;
  top: 8px;
  z-index: 999;
  max-height: 100vh;
  overflow-y: scroll;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 6px;
}

.border-text {
  //font-family: Source Han Sans CN;
  //font-weight: bold;
  font-size: 18px;
  //color: #101828;
}

.go-back-style {
  text-align: start;
  width: 1240px;
  margin: 0 auto;
  padding: 10px 0 5px;
}
.go-back-title {
  font-size: 14px;
  color: #667085;
  cursor: pointer;
  cursor: pointer;
}
</style>
